//test
export default {
    /**
     * 获取用户个人信息
     */
    getUserInfo(state) {
        return state.userInfo
    }
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js